import * as React from 'react';
import { useState, useEffect } from 'react';
import { Chart } from '@statisticsfinland/pxvisualizer';
import iPxGraphData from './ResponseModels/iPxGraphData';
import iPxGraphModel from './iPxGraph';
import iPxGraphPropsModel from './iPxGraphProps';
import DataHelper from './DataHelper';
import DisplayHelper from './DisplayHelper';
import { uniqueKey } from 'highcharts';

const PxGraph = (props: iPxGraphPropsModel) => {

    const [delayed, setDelayed] = useState(true);
    const [state, setState] = useState<iPxGraphModel>(props);

    useEffect(() => {
        getGraphData();
    }, []);

    useEffect(() => {
        const timeout = setTimeout(() => setDelayed(false), 3000);
        return () => clearTimeout(timeout);
    }, []);

    const getGraphData = async () => {
        await DataHelper.FetchPXGraphData(state.graphId, initializeGraph);
    };

    const initializeGraph = (graphData: iPxGraphData) => {

        if (!graphData || !graphData.selectableVariableCodes) {
            console.warn("Graph data is invalid or missing required fields.");
            return;
        }

        let availableYears = graphData.metaData.filter((d) => {return d.name.sv === 'År'})[0].values.map(d => d.code);

        let textReplacements = {
            FROM: availableYears[0],
            TO: availableYears[availableYears.length-1],
        };
        let headTitle = state.headTitle.includes('[FROM]') || state.headTitle.includes('[TO]') ?
                        DisplayHelper.ReflectDataInText(state.headTitle, textReplacements) : state.headTitle;

        setState(prev => ({ ...prev, headTitle, graphData }));
    };

    return (
        <React.Fragment key={uniqueKey()}>
            <h3>{state.headTitle}</h3>
            <div className="graph-container">
                <div className="scroll-container">
                    {state.graphData && state.graphData.selectableVariableCodes ? (
                        <Chart
                            pxGraphData={state.graphData}
                            locale={DisplayHelper.GetLocale()}
                            selectedVariableCodes={{}} 
                        />
                    ) : delayed ? (
                        <div>Laddar graf...</div>
                    ) : (
                        <div>
                            <p><span className="label label-danger">Fel vid rendering av graf</span></p>
                            <p><strong>ID:</strong> <code>{state.graphId}</code></p>
                        </div>
                    )}

                </div>
            </div>
        </React.Fragment>
    );
};
export default PxGraph;